import axios from '../axios';
const END_POINT = '/services';

const addService = (service) => axios.post(`${END_POINT}`, service);
const getServices = (payload) => axios.get(`${END_POINT}?limit=${payload.limit}&page=${payload.page}`);
const updateService = (serviceId, payload) => axios.patch(`${END_POINT}/${serviceId}`, payload);
const searchService = (payload) => axios.post(`${END_POINT}/search`, payload);
const deleteService = (servicesId) => axios.delete(`${END_POINT}/${servicesId}`);
const findAService = (serviceId) =>  axios.get(`${END_POINT}/${serviceId}`);
const getOneService = (serviceId) => axios.get(`${END_POINT}/${serviceId}`);
const getLabService = (payload) => axios.post(`${END_POINT}/lab`, payload);

export {
    addService, getServices, updateService, searchService, findAService,deleteService,getOneService,getLabService
}